// removed by extract-text-webpack-plugin
module.exports = {"App":"_2tUMBBOK","App-logo":"_2UEwbfG2","App-logo-spin":"APzGggMG","App-header":"_33WDyc4U","App-title":"_3irWljsL","App-intro":"_20zH3Ia4"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/App.styl
// module id = 197
// module chunks = 0